import LoadController from  "../controllers/load_controller";
export default LoadController;